'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.spinnerProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SpinnerModule = require('./Spinner.module.css');

var _SpinnerModule2 = _interopRequireDefault(_SpinnerModule);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SpinnerIcon = require('./SpinnerIcon');

var _SpinnerIcon2 = _interopRequireDefault(_SpinnerIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spinner = function Spinner(_ref) {
    var message = _ref.message,
        _ref$center = _ref.center,
        center = _ref$center === undefined ? true : _ref$center,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        _ref$loading = _ref.loading,
        loading = _ref$loading === undefined ? true : _ref$loading,
        _ref$role = _ref.role,
        role = _ref$role === undefined ? 'alert' : _ref$role,
        _ref$ariaLive = _ref.ariaLive,
        ariaLive = _ref$ariaLive === undefined ? 'assertive' : _ref$ariaLive,
        _ref$size = _ref.size,
        size = _ref$size === undefined ? '4x' : _ref$size,
        color = _ref.color,
        children = _ref.children;
    return loading ? _react2.default.createElement(
        'div',
        { className: (center ? _SpinnerModule2.default.center : '') + ' ' + className,
            'aria-busy': loading,
            'aria-live': ariaLive,
            'aria-label': message,
            role: role },
        _react2.default.createElement(_SpinnerIcon2.default, { size: size, color: color }),
        children
    ) : null;
};

var spinnerProps = exports.spinnerProps = _extends({}, _SpinnerIcon.spinnerIconProps, {
    message: _propTypes2.default.string.isRequired,
    center: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    loading: _propTypes2.default.bool,
    role: _propTypes2.default.string,
    ariaLive: _propTypes2.default.string,
    children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.node)])
});

Spinner.propTypes = spinnerProps;

exports.default = Spinner;